import { CORPORATE_VERIFICATION_ERROR_CODES } from '@/apps/bh_benefits/upgrade/helpers/corporateVerificationErrors';

export type CorporateVerificationTokenResult = 'verification' | 'manual_fallback' | false;

export function resolveCorporateVerificationTokenResult(error: unknown): CorporateVerificationTokenResult {
  const errorCode = (error as { graphQLErrors?: Array<{ extensions?: { error_code?: string } }> })?.graphQLErrors?.[0]?.extensions
    ?.error_code;

  if (errorCode === CORPORATE_VERIFICATION_ERROR_CODES.WORK_EMAIL_PREVIOUSLY_USED) {
    return 'manual_fallback';
  }

  return false;
}
